import _extends from "@babel/runtime/helpers/extends";
import { Button as WDSButton, Tooltip, Box } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import s from './EclipseCta.scss';
export const EclipseCta = _ref => {
  let {
    onClick,
    children,
    disabled,
    disabledTooltipContent,
    onShowTooltip,
    variant = 'primary',
    fullWidth,
    size = 'large',
    ...props
  } = _ref;
  const shouldShowTooltip = disabled && disabledTooltipContent;
  return /*#__PURE__*/React.createElement(Box, {
    width: fullWidth ? '100%' : 'auto',
    verticalAlign: "middle",
    align: "center"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    disabled: !shouldShowTooltip,
    placement: "bottom",
    content: disabledTooltipContent,
    className: s.eclipseCtaTooltip,
    onShow: onShowTooltip
  }, /*#__PURE__*/React.createElement(WDSButton, _extends({
    className: classNames(s.eclipseCta, {
      [s.primary]: variant === 'primary',
      [s.secondary]: variant === 'secondary',
      [s.dark]: variant === 'dark',
      [s.disabled]: disabled
    }),
    onClick: onClick,
    fullWidth: fullWidth,
    disabled: disabled,
    size: size
  }, props), children)));
};
//# sourceMappingURL=EclipseCta.js.map